import React from 'react'
import styles from './BenefitCard.module.css'
import BenefitCard from './BenefitCard'
import {DentalOpticalBenefit} from '@peachy/legacy-domain'


const benefitTemplate = DentalOpticalBenefit()

export default function DentalOpticalCard () {

    return (
        <BenefitCard header={'Dental & optical care'} className={styles.dentalOptical} benefitTemplate={benefitTemplate}>
            <p>Teeth &amp; eyes need tender loving care too!</p>
            <p>Cashback for dental care (£200 benefit limit per plan year) &amp; optical care (£100 benefit limit per plan year)</p>
        </BenefitCard>
    )
}
